import React from 'react';
import { Episode } from '../types';

interface EpisodeListProps {
  episodes: Episode[];
  onPlay: (episode: Episode) => void;
  onDownload: (episode: Episode) => void;
}

const EpisodeList: React.FC<EpisodeListProps> = ({ episodes, onPlay, onDownload }) => {
  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="episode-list">
      {episodes.map((episode) => (
        <div key={episode.id} className="episode-item">
          <div className="episode-info">
            <span className="episode-date">{formatDate(episode.pubDate)}</span>
            {episode.episodeNumber && (
              <span className="episode-number">{episode.episodeNumber}:</span>
            )}
            <span className="episode-title">{episode.title}</span>
          </div>
          <div className="episode-actions">
            <button onClick={() => onPlay(episode)} className="play-button">
              Play
            </button>
            <button
              onClick={() => onDownload(episode)}
              className="download-button"
              title="Download MP3"
            >
              ⬇ mp3
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EpisodeList;
